<template>
  <div class="page">

    <img src="@/assets/001.jpg" class="banner" alt="banner" @click="handleClick" />
    <img src="@/assets/002.jpg" class="banner" alt="banner" />
    <img src="@/assets/003.jpg" class="banner" alt="banner" />
    <img src="@/assets/004.jpg" class="banner" alt="banner" />
    <img src="@/assets/005.jpg" class="banner" alt="banner" />

  </div>
</template>

<script>
export default {
  name: 'Page1',
  methods: {
    handleClick() {
       //跳转 a标签
       window.open('https://edu.xiaoyiduo.cn')


    }
  }
}
</script>

<style scoped>
.banner{
  max-width: 100%;
   
}
</style>